import { localized } from '@platform/core/lib/localized';
import type { IModuleI18n, Lang } from '@platform/core/types';
import type { ISubTableDef } from './ISubTableDef';

/**
 * Підпис картки підтаблиці (прототип: «Команда: справа», «Результати робіт»): рядок пакета модуля `entities.<тип>.subTable.label` → підпис
 * ознаки визначення мовою інтерфейсу → назва дочірнього типу. Чиста функція.
 */
export function subTableLabel(def: Pick<ISubTableDef, 'child' | 'label'>, bundle: IModuleI18n | undefined, lang: Lang, typeName: string): string {
  const own = (bundle?.entities?.[def.child.key] as { subTable?: { label?: unknown } } | undefined)?.subTable?.label;
  if (typeof own === 'string' && own) return own;
  return (def.label ? localized(def.label, lang) : '') || typeName;
}
